import { AuthGuard, AuthGuardWithEmailAccess } from '@/auth/auth-guards';
import type { RouteLocation, RouteRecordRaw } from 'vue-router';
import { salesAgreementMessages } from '../back-office-messages';
import { RoutePaths } from '../route-paths';
import { Permission, ArcualTransferType } from '@arcual/lib-app-platform';

export const salesAgreementRoutes: Array<RouteRecordRaw> = [
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.SELL.SALES_AGREEMENT,
    component: () => import(`./sales-agreements-list/SalesAgreementSellList.vue`),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_SALES_AGREEMENTS),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.BUY.SALES_AGREEMENT,
    component: () => import(`./sales-agreements-list/SalesAgreementsBuyList.vue`),
    beforeEnter: (to: RouteLocation) => AuthGuard(to),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.SELL.SALES_AGREEMENT_CREATE,
    component: () => import(`./create/CreateSalesAgreement.vue`),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.CREATE_SALES_AGREEMENT),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.SELL.SALES_AGREEMENT_DETAILS,
    component: () => import(`./create/CreateSalesAgreement.vue`),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_SALES_AGREEMENTS),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.SELL.TRANSFER_CREATE,
    component: () => import(`./create/CreateSalesAgreement.vue`),
    props: {
      role: ArcualTransferType.MANUAL_TRANSFER,
    },
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.CREATE_SALES_AGREEMENT),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.SELL.TRANSFER_DETAILS,
    component: () => import(`./create/CreateSalesAgreement.vue`),
    props: {
      role: ArcualTransferType.MANUAL_TRANSFER,
    },
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_SALES_AGREEMENTS),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.BUY.SALES_AGREEMENT_DETAILS,
    component: () => import(`./SalesAgreement.vue`),
    // todo we need an auth guard and more flexible structure for guest access
    beforeEnter: (to: RouteLocation) => AuthGuardWithEmailAccess(to),
  },
  {
    meta: { title: salesAgreementMessages.createTitle },
    path: RoutePaths.BUY.TRANSFER_DETAILS,
    component: () => import(`./Transfer.vue`),
    // todo we need an auth guard and more flexible structure for guest access
    beforeEnter: (to: RouteLocation) => AuthGuardWithEmailAccess(to),
  },
];
